import Vue from 'vue'

export default new Vue()


// WEBPACK FOOTER //
// ./src/shared/event-bus.js